import { useState, useCallback } from 'react';
import { ToastProvider as ToastContextProvider } from '../../../contexts/toast';
import ToastContainer from '../ToastContainer';
import ThemeLayout from '../../../layouts/Theme';

let id = 0;

const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const openToast = useCallback(
    (props) => {
      let toastId = id++;
      setToasts((toasts) => [
        ...toasts,
        {
          id: toastId,
          key: toastId,
          ...props,
        },
      ]);
    },
    [setToasts]
  );

  const closeToast = useCallback(
    (id) => {
      setToasts((toasts) => toasts.filter((t) => t.id !== id));
    },
    [setToasts]
  );

  return (
    <ToastContextProvider
      value={{
        openToast,
        closeToast,
      }}
    >
      <ThemeLayout hasChildren>
        <ToastContainer toasts={toasts} />
      </ThemeLayout>
      {children}
    </ToastContextProvider>
  );
};

export default ToastProvider;
